import { render, staticRenderFns } from "./SimpleChars.vue?vue&type=template&id=01af420a&scoped=true"
import script from "./SimpleChars.vue?vue&type=script&lang=js"
export * from "./SimpleChars.vue?vue&type=script&lang=js"
import style0 from "./SimpleChars.vue?vue&type=style&index=0&id=01af420a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af420a",
  null
  
)

export default component.exports